import React from 'react';
import { translate } from '../../../../Services/translation';
import { cn } from '../../../../Utils/cn';
import CheckoutPaymentWidget from './components/CheckoutPaymentWidget';
import CheckoutPaymentForm from './components/CheckoutPaymentForm/CheckoutPaymentForm';

const CheckoutPayment = ({ checkout }) => {
  const { payload } = checkout || {};
  const {
    isBusinessCustomer,
    isPaymentLoading,
    paymentWidget,
    termsUrl: termsAndConditionsLink,
    termsAndConditionsLinkText: termsAndConditionsText,
  } = payload || {};

  return (
    <div className="checkout-section">
      <h2 className="heading-2 mb-8">{translate('checkout.payment.title')}</h2>

      {!isBusinessCustomer &&
        (paymentWidget?.responseString || isPaymentLoading) && (
          <div className={cn(isPaymentLoading && 'min-h-128 relative')}>
            <CheckoutPaymentWidget
              responseString={paymentWidget?.responseString}
            />
            {isPaymentLoading && (
              <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
                <div className="icon">hourglass</div>
              </div>
            )}
          </div>
        )}

      <CheckoutPaymentForm checkout={checkout} />

      {!!termsAndConditionsLink && !!termsAndConditionsText && (
        <div className="mt-8 text-center">
          <a
            className="link"
            href={termsAndConditionsLink}
            target="_blank"
            rel="noreferrer"
          >
            {termsAndConditionsText}
          </a>
        </div>
      )}
    </div>
  );
};

export default CheckoutPayment;
